export default __webpack_public_path__ + "static/icon-tie-back-aaa7f3b0647b295219b83f0879f0d1fe.webp";